export default {
  navigation: {
    sections: {
      platform: 'Platform',
      moderation: 'Moderation',
      website: 'Website',
      configuration: 'Configuration',
      administration: 'Administration',
    },
    jobs: 'Jobs',
    industries: 'Industries',
    cities: 'Cities',
    profiles: 'Users',
    notifications: 'Notifications',
    reports: 'Reports',
    services: 'Services',
    dashboard: 'Dashboard',
    projects: 'Projects',
    quotes: 'Submisions',
    reviews: 'Evaluations',
    settings: 'Settings',
    freelancers: 'Freelancers',
    recruiters: 'Recruiters',
    blog: 'Blog',
    articles: 'Articles',
    websiteMedia: 'Website media',
    websiteContent: 'Website content',
    serviceCatalog: 'Service catalog',
    campaigns: 'Campaigns',
    categories: 'Categories',
    tags: 'Tags',
    creditGifts: 'Credit gifts',
    credits: 'Credits',
    creditTransactions: 'Credit transactions',
    create: 'Add an administrator',
    userLookup: 'Find a user',
  },
  creditGift: {
    title: 'Gift credits',
    giftCredits: 'Gift credits',
    recipient: 'Recipient',
    amount: 'Amount',
    reasonOptional: 'Reason (optional)',
    submit: 'Gift credits',
    success: 'Credits gifted successfully',
    invalidAmount: 'Amount must be positive',
  },
  creditGiftConfig: {
    title: 'Credit gifts',
    subtitle:
      'Choose one option: signup credits or monthly credits. They cannot be active at the same time.',
    modeLabel: 'Automatic credit gift',
    modeOff: 'Off',
    modeSignup: 'Signup credits',
    modeMonthly: 'Monthly credits',
    signupAmounts: 'Credits on signup (per role)',
    monthlyAmounts: 'Monthly credits (per role)',
    monthlyObnlLabel: 'Organization (OBNL)',
    monthlyCumulative:
      'Cumulative (unused credits roll over). If unchecked, balance is reset each month.',
    save: 'Save',
    saved: 'Configuration saved',
    invalidAmounts: 'Amounts must be 0 or more',
  },
  creditTransactions: {
    title: 'Credit transactions',
    availableCredits: 'Available credits',
    viewUserTransactions: 'View credit transactions',
    filteredByUser: 'Filtered for:',
    filteredByUserFallback: 'Selected user',
    clearUserFilter: 'Remove user filter',
    userSearch: 'Search a user',
    searchPlaceholder: 'Name or email',
    type: 'Type',
    period: 'Period',
    startDate: 'Start date',
    endDate: 'End date',
    periodPresets: {
      all: 'All time',
      lastWeek: 'Last week',
      lastMonth: 'Last month',
      lastQuarter: 'Last quarter',
      custom: 'Custom',
    },
    columns: {
      date: 'Date',
      user: 'User',
      reason: 'Reason',
      type: 'Type',
      amount: 'Amount',
      balance: 'Balance',
    },
    actionTypes: {
      purchase: 'Credit purchase',
      refund: 'Refund',
      admin_adjustment: 'Admin adjustment',
      signup_gift: 'Signup gift',
      monthly_gift: 'Monthly gift',
      send_alliance_request: 'Sent an alliance request',
      accept_quote_request: 'Accepted a quote request',
      accept_quote_alliance_request: 'Accepted an alliance quote request',
      submit_public_job_quote: 'Submitted a quote on a public job',
      publish_job_standard: 'Published a standard job',
      publish_job_featured: 'Published a featured job',
      publish_job_urgent: 'Published an urgent job',
    },
  },
  table_fields: {
    title: 'Title',
    description: 'Description',
    on_site: 'On site',
    languages: 'Languages',
    start_date: 'Start date',
    end_date: 'End date',
    status: 'Status',
    visibility: 'Visibility',
    published_at: 'Published at',
    expires_at: 'Quote submission deadline',
    selection_date: 'Expected response date',
    created_at: 'Created at',
    updated_at: 'Updated at',
    completed_at: 'Completed at',
    budget_range: 'Budget',
    client: 'Client',
    city: 'City',
    listing_type: 'Listing type',
    service_category: 'Service category',
    is_active: 'Active',
    first_name: 'First name',
    last_name: 'Last name',
    phone: 'Phone',
    is_remote: 'Remote',
    postal: 'Postal code',
    role: 'Role',
    company_type: 'Company type',
    company_name: 'Company name',
    job_title: 'Job title',
    organization_website: 'Organization website',
    organization_number: 'Organization number',
    obnl_review_status: 'OBNL review status',
    avatar_url: 'Avatar URL',
    slug: 'Slug',
    label: 'Label',
    label_fr: 'Label (French)',
    label_en: 'Label (English)',
    name: 'Name',
    code: 'Code',
    latitude: 'Latitude',
    longitude: 'Longitude',
    reporter: 'Reporter',
    reporter_email: 'Reporter email',
    reported: 'Reported',
    content_type: 'Content type',
    reported_content: 'Reported content',
    entity: 'Entity',
    reason: 'Reason',
    details: 'Details',
    admin_notes: 'Admin notes',
    resolved_at: 'Resolved at',
    reviewer: 'Reviewer',
    reviewed: 'Reviewed',
    quote: 'Quote',
    rating: 'Rating',
    comment: 'Comment',
    validated: 'validated',
    destination_profile: 'Receiver',
    source_profile: 'Sender',
    payload: 'Payload',
    read_at: 'Read at',
    email_sent: 'Email sent',
    suggested_by: 'suggested by',
    user: 'User',
    company: 'Company',
    owner: 'Owner',
    type: 'Type',
    actions: 'Actions',
    deleted: 'Deleted',
  },
  common: {
    search: 'Search...',
    cancel: 'Cancel',
    submit: 'Submit',
  },
  obnlReview: {
    approve: 'Approve OBNL',
    reject: 'Reject OBNL',
    approvedSuccess: 'OBNL status approved successfully',
    rejectedSuccess: 'OBNL status rejected successfully',
    error: 'Could not update the OBNL review status.',
  },
  deleteUser: {
    deleteButton: 'Delete user',
    title: 'Delete user',
    warning:
      'You are about to permanently delete {{username}}. Their personal information will be erased and they will no longer be able to log in. This action cannot be undone.',
    confirmPrompt: 'Type {{word}} to confirm',
    confirmWord: 'DELETE',
    confirmButton: 'Delete user',
    success: 'User deleted successfully',
    error: 'Could not delete this user.',
  },
  generateAuthLink: {
    buttonTooltip: 'Generate login link',
    title: 'Generate login link',
    loading: 'Generating link...',
    magiclinkHelp: 'This link lets the user confirm their account and sign in.',
    recoveryHelp: 'This link lets the user set a new password.',
    copyButton: 'Copy link',
    copied: 'Link copied',
    copyError: 'Could not copy this link.',
    error: 'Could not generate a link for this user.',
  },
  userLookup: {
    title: 'Find a user',
    emailLabel: 'Email',
    emailPlaceholder: 'name@example.com',
    searchButton: 'Search',
    notFound: 'No user found with this email.',
    confirmed: 'Confirmed',
    unconfirmed: 'Unconfirmed',
    generateLinkButton: 'Generate link',
    error: 'Could not look up this user.',
  },
  search_cities: 'Search cities',
  search_cities_placeholder: 'Search by city name or code…',
  cities_no_search_results: 'No cities match this search.',
  cities_empty: 'No cities in the database yet.',
  city_code_hint:
    'Use the regional municipality code (e.g. 10) that matches the Ministère des Affaires municipales dataset. The pair name + code must be unique.',
  invalid_number: 'Enter a valid number or leave empty.',
  cancel_this_job: 'Cancel this job',
  cancel_this_hint: 'This action cannot be undone. The job will be canceled from the platform.',
  manage_review: 'Manage Review',
  view_all_users: 'View all users',
  recent_users: 'Recent Users',
  user_search_label: 'Search users',
  user_search_placeholder: 'Name, email, phone or company...',
  userActivity: {
    title: 'User activity',
    quotes: 'Quotes',
    projects: 'Projects',
    jobs: 'Job offers',
    empty: 'No activity to display.',
    loadError: 'Could not load this user activity.',
    quotesCount_one: '{{count}} quote',
    quotesCount_other: '{{count}} quotes',
  },
  add_admin: 'Add Administrator',
  create_admin_success: 'Administrator created successfully',
  edit_industry: 'Edit Industry',
  edit_service_category: 'Edit Service Category',
  industry_details: 'Industry Details',
  service_category_details: 'Service Category Details',
  blogAdmin: {
    new_post: 'New article',
    edit_post: 'Edit article',
    title: 'Title',
    slug: 'Slug',
    content: 'Content',
    excerpt: 'Excerpt',
    category: 'Category',
    categories: 'Categories',
    tags: 'Tags',
    status: 'Status',
    published_at: 'Published at',
    featured_image: 'Featured image',
    seo_ia: 'SEO & AI',
    seo_title: 'Meta Title',
    seo_description: 'Meta Description',
    ai_summary: 'AI Summary',
    save: 'Save',
    saving: 'Saving...',
    delete: 'Delete',
    cancel: 'Cancel',
    upload_image: 'Click to upload',
    scheduled_at: 'Scheduled for',
    scheduled: 'Scheduled',
    author: 'Author',
    select_author: 'Select an author',
    you_are_selected: 'You (by default)',
    writing_guide_title: 'Writing a great article',
    writing_guide_text:
      'Use a clear title, structured headings, and keywords for better SEO and AI indexing. A good featured image increases engagement.',
    blog_logic: 'Advanced and structured editing',
    title_placeholder: 'Enter title here',
    excerpt_placeholder: 'Short summary of the article for lists...',
    seo_hint: 'Google search preview and AI summary',
    ai_summary_placeholder: 'Write an ultra-optimized summary for AI search engines here...',
    category_name_prompt: 'New category name:',
    add_tag: 'Search or add tag...',
    required_fields: 'Title and Slug are required',
    update_success: 'Article updated successfully',
    create_success: 'Article created successfully',
    save_error: 'Error while saving',
    confirm_delete: 'Are you sure you want to delete this article?',
    delete_success: 'Article deleted',
    image_upload_success: 'Image uploaded successfully',
    image_upload_error: 'Error while uploading image',
    uploading_image: 'Uploading image...',
    uploading: 'Uploading...',
    category_created: 'Category created successfully',
    tag_created: 'Tag created successfully',
    create_category: 'Create category',
    create_tag: 'Create tag',
    required_size: 'Preferred size: 1200x630px',
    max_chars: 'Recommended max characters:',
    title_limit: '70 characters',
    slug_limit: 'Slug should be URL friendly',
    preview_label: 'Preview',
    preview_edit: 'Edit',
    preview_split: 'Split',
    preview_only: 'Preview only',
    preview_empty_title: 'Article title',
    preview_empty_excerpt: 'The excerpt will appear here as soon as it is added.',
    preview_empty_content: 'The editor content will render here in preview mode.',
    go_to_preview: 'Go to preview',
    go_to_preview_hint:
      'Opens the article on the public site in preview mode. Sign in there with your admin account if needed.',
    language_section: 'Language',
    edit_other_locale: 'Edit {{locale}} version',
    create_other_locale: 'Create {{locale}} version',
    filter_all_status: 'All statuses',
    filter_all_locales: 'All languages',
    filter_locale_fr: 'French only',
    filter_locale_en: 'English only',
    locale_column: 'Lang.',
    image_library: 'Media library',
    image_library_hint: 'Images uploaded for blog posts (same folder as new uploads).',
    image_library_empty:
      'No images yet. Upload an image using the editor or the featured image area first.',
    choose_from_library: 'Choose from library',
    insert_image_upload: 'Upload a new image',
    insert_image_library: 'Insert an image from the library',
    manage_posts_subtitle: 'Create and manage your editorial content',
    no_posts_title: 'No articles for now',
    no_posts_hint: 'Start by creating your first article!',
    name: 'Name',
    description: 'Description',
    add: 'Add',
    update: 'Update',
    edit_category: 'Edit category',
    manage_categories_hint: 'Create and manage categories to organize your articles.',
    category_updated: 'Category updated successfully',
    confirm_delete_category: 'Are you sure you want to delete this category?',
    category_deleted: 'Category deleted successfully',
    edit_tag: 'Edit tag',
    manage_tags_hint: 'Create and manage tags to organize your articles.',
    tag_updated: 'Tag updated successfully',
    confirm_delete_tag: 'Are you sure you want to delete this tag?',
    tag_deleted: 'Tag deleted successfully',
    confirm_delete_category_hint:
      "Are you sure you want to delete this category? Associated articles won't be deleted but will lose this category.",
    confirm_delete_tag_hint: 'Are you sure you want to delete this tag?',
    confirm_delete_hint: 'This action is irreversible. The article will be permanently removed.',
    enter_link_url: 'Enter link URL',
    insert_link: 'Insert link',
    enter_iframe_url: 'Enter trusted iframe embed URL (iframe src)',
    enter_iframe_title: 'Enter a descriptive title for this embed (for accessibility)',
    default_iframe_title: 'Embedded content',
    insert_iframe: 'Insert iframe',
    iframe_untrusted_origin:
      'This iframe origin is not trusted. Use an https embed URL from an allowlisted origin.',
    iframe_not_embeddable:
      "This URL isn't an embeddable link. Use the provider's embed URL (e.g. /embed/... for YouTube, /video/... for Vimeo).",
    iframe_allowlist_empty: 'Iframe embeds are disabled. Configure trusted origins first.',
  },
  websiteMedia: {
    title: 'Website media',
    subtitle:
      'Manage the marketing and fallback photos used on the public website. Brand logos and decorative SVGs still stay in code.',
    upload: 'Upload image',
    clear: 'Clear override',
    save: 'Save changes',
    saving: 'Saving...',
    image_uploaded: 'Image uploaded successfully',
    image_upload_error: 'Error while uploading image',
    save_success: 'Website media saved successfully',
    save_error: 'Error while saving website media',
    clear_success: 'Override removed. The website now uses the default image again.',
    clear_error: 'Error while removing the override',
    override_active: 'Override active',
    using_default: 'Using default',
    shared_locale_hint: 'Images are shared across FR and EN. Alt text is localized per language.',
    alt_hint: 'Use concise descriptive alt text so the image stays accessible when changed.',
    unknown_error: 'Unknown error',
    fields: {
      image_url: 'Image URL',
      alt_text_fr: 'French alt text',
      alt_text_en: 'English alt text',
    },
    pages: {
      home: 'Home page',
      about: 'About page',
      resources: 'Resources page',
    },
    sections: {
      home: {
        testimonials: 'Testimonials',
        features: 'Feature cards',
        pricing: 'Pricing block',
      },
      about: {
        belief: 'Belief section',
        alliances: 'Alliances section',
        village_marquee: 'Village marquee',
        village_scroll: 'Scrolling tiles',
      },
      resources: {
        fallbacks: 'Fallback article images',
      },
    },
    placements: {
      home_testimonial_1: 'Testimonial 1',
      home_testimonial_2: 'Testimonial 2',
      home_testimonial_3: 'Testimonial 3',
      home_testimonial_4: 'Testimonial 4',
      home_feature_1: 'Feature card 1',
      home_feature_2: 'Feature card 2',
      home_feature_3: 'Feature card 3',
      home_pricing_photo: 'Pricing photo',
      about_belief_photo: 'Belief photo',
      about_alliances_background: 'Alliances background',
      about_village_marquee_1: 'Village marquee image 1',
      about_village_marquee_2: 'Village marquee image 2',
      about_village_marquee_3: 'Village marquee image 3',
      about_village_marquee_4: 'Village marquee image 4',
      about_village_scroll_1: 'Scrolling tile image 1',
      about_village_scroll_2: 'Scrolling tile image 2',
      about_village_scroll_3: 'Scrolling tile image 3',
      resources_featured_fallback: 'Featured article fallback',
      resources_freelancer_fallback: 'Freelancer section fallback',
      resources_recruiter_fallback: 'Recruiter section fallback',
      resources_other_fallback: 'Other resources fallback',
    },
  },
  websiteContent: {
    title: 'Website content',
    subtitle: 'Pick a page to manage its photos.',
    back_to_pages: 'Back to pages',
    photo_count_one: '{{count}} photo',
    photo_count_other: '{{count}} photos',
    upload: 'Upload image',
    choose_from_library: 'Choose from library',
    image_library: 'Website media library',
    image_library_hint: 'Images already uploaded for this page.',
    image_library_empty: 'No images yet. Upload an image first, then you can reuse it here.',
    image_selected: 'Image applied',
    clear: 'Clear override',
    save: 'Save changes',
    saving: 'Saving...',
    image_uploaded: 'Image uploaded successfully',
    image_upload_error: 'Error while uploading image',
    save_success: 'Website content saved successfully',
    save_error: 'Error while saving website content',
    invalid_image_host:
      "This image URL's host isn't allowed. Use the upload button or the library, or paste a URL from an allowed host.",
    clear_success: 'Override removed. The website now uses the default image again.',
    clear_error: 'Error while removing the override',
    override_active: 'Override active',
    using_default: 'Using default',
    shared_locale_hint: 'Images are shared across FR and EN. Alt text is localized per language.',
    unknown_error: 'Unknown error',
    no_image: 'No image yet',
    fields: {
      image_url: 'Image URL',
      alt_text_fr: 'French alt text',
      alt_text_en: 'English alt text',
    },
    pages: {
      global: 'Global',
      home: 'Home page',
      about: 'About page',
      services: 'Services page',
      resources: 'Resources page',
      pricing: 'Pricing page',
    },
    sections: {
      global: {
        social_share: 'Social share',
      },
      home: {
        avatars: 'Freelancer photos',
        photos: 'Photos',
      },
      about: {
        photos: 'Photos',
      },
      services: {
        hero: 'Hero block',
      },
      resources: {
        fallbacks: 'Fallback article images',
      },
      pricing: {
        hero: 'Hero block',
      },
    },
    placements: {
      home_freelancer_avatar_1: 'Photo 1',
      home_freelancer_avatar_2: 'Photo 2',
      home_freelancer_avatar_3: 'Photo 3',
      home_freelancer_avatar_4: 'Photo 4',
      home_freelancer_avatar_5: 'Photo 5',
      home_freelancer_avatar_6: 'Photo 6',
      about_photo_1: '1st photo',
      about_photo_2: '2nd photo',
      about_photo_3: '3rd photo',
      home_dashboard_photo: 'Dashboard screenshot',
      home_guide_pigistes_photo: 'Freelancer guide photo',
      home_guide_recruteurs_photo: 'Recruiter guide photo',
      home_feature_pigistes_photo: 'Feature card: freelancers',
      home_feature_annonces_photo: 'Feature card: job posts',
      home_feature_alliances_photo: 'Feature card: alliances',
      services_hero_photo: 'Hero photo',
      resources_featured_fallback: 'Featured article fallback',
      resources_freelancer_fallback: 'Freelancer section fallback',
      resources_recruiter_fallback: 'Recruiter section fallback',
      resources_other_fallback: 'Other resources fallback',
      pricing_hero_photo: 'Pricing hero photo',
      social_share_image: 'Social share image (1200 x 630 px recommended)',
    },
  },
  jobActivityHub: {
    title: 'Job activity hub',
    fallback_title: 'Job',
    back_to_jobs: 'Back to jobs',
    refresh: 'Refresh',
    invalid_job: 'Missing job id.',
    unread_section: 'Notification read state (by participant)',
    unread_help:
      'Unread counts include in-app notifications whose payload references this job (e.g. hub messages and job alerts).',
    no_participants: 'No participants found for this job.',
    unread_count: '{{count}} unread',
    all_seen: 'All read',
    no_hub_threads:
      'No recruiter hub view is available yet (for example, a public job with no quotes or submissions).',
    perspective_label: 'View as',
    perspective_help:
      'Switch between the recruiter (client) inbox and a principal freelancer’s hub to see client ↔ freelancer threads or freelancer ↔ alliance threads.',
    perspective_recruiter: 'Recruiter (client)',
    perspective_freelancer: 'Principal freelancer',
    principal_offer_label: 'Principal offer',
    dashboard_section_title: 'Recent jobs — activity hub',
    dashboard_section_subtitle: 'Open the read-only activity hub for any recent job.',
    view_all_jobs: 'All jobs',
    no_recent_jobs: 'No jobs found.',
    open_hub: 'Open activity hub',
    open_hub_short: 'Hub',
    actions_column: 'Activity',
    view_details: 'View job details',
    details_load_error: 'Could not load the job details. Please try again.',
  },
  status: {
    draft: 'Draft',
    published: 'Published',
    scheduled: 'Scheduled',
  },
  serviceCatalog: {
    title: 'Service catalog',
    subtitle:
      'Manage the featured services, their linked freelancer types, and the lead-capture chatbot.',
    tabs: {
      items: 'Services',
      freelancerTypes: 'Freelancer types',
      leads: 'Leads',
    },
    itemsSubtitle: 'The services shown in the public catalog.',
    addItem: 'Add a service',
    addFreelancerType: 'Add a type',
    addBenefitTag: 'Add a benefit',
    addOption: 'Add an option',
    deleteQuestion: 'Delete question',
    itemCreated: 'Service created',
    saveSuccess: 'Saved',
    save: 'Save',
    saving: 'Saving...',
    confirmDelete: 'Are you sure you want to delete this?',
    genericError: 'Something went wrong',
    deactivateToEditQuestions:
      'Deactivate this service before adding a new question — a newly added question has no options yet and would immediately dead-end the live chatbot.',
    active: 'Active',
    inactive: 'Inactive',
    noLeads: 'No leads yet.',
    fields: {
      active: 'Active',
      slug: 'Slug',
      nameFr: 'Name (FR)',
      nameEn: 'Name (EN)',
      categoryFr: 'Category (FR)',
      categoryEn: 'Category (EN)',
      shortDescriptionFr: 'Short description (FR)',
      shortDescriptionEn: 'Short description (EN)',
      fullDescriptionFr: 'Full description (FR)',
      fullDescriptionEn: 'Full description (EN)',
      chatbotGreetingFr: 'Chatbot greeting (FR)',
      chatbotGreetingEn: 'Chatbot greeting (EN)',
      chatbotIntroFr: 'Chatbot intro (FR)',
      chatbotIntroEn: 'Chatbot intro (EN)',
      freelancerTypes: 'Linked freelancer types',
      benefitTags: 'Benefits ("This service is for")',
      chatbotQuestions: 'Chatbot questions',
      labelFr: 'Label (FR)',
      labelEn: 'Label (EN)',
      questionTextFr: 'Question (FR)',
      questionTextEn: 'Question (EN)',
      placeholderFr: 'Placeholder (FR)',
      placeholderEn: 'Placeholder (EN)',
      optional: 'Optional (shows a Skip button)',
      gotoNext: 'Next step (default)',
      createdAt: 'Received',
      serviceName: 'Service',
      email: 'Email',
      phone: 'Phone',
      locale: 'Language',
      status: 'Status',
      answers: 'Answers',
    },
    stepTypes: {
      text: 'Free text',
      choice: 'Multiple choice',
      contact: 'Contact info',
    },
    leadStatus: {
      new: 'New',
      contacted: 'Contacted',
      closed: 'Closed',
    },
  },
  loading: 'Loading...',
  loadMore: 'Load more',
  create_admin: 'Add an administrator',
  city: 'City',
  phone: 'Phone',
  email: 'Email',
  informations: 'Information',
  allServicesTitle: 'All services',
  pendingServicesTitle: 'Pending services',
  pendingServicesEmpty: 'No pending services',
  industryDeleted: 'Industry deleted',
  industryDeleteError: 'Failed to delete industry',
  serviceCategoryDeleted: 'Service category deleted',
  serviceCategoryDeleteError: 'Failed to delete service category',
  service_category_label_hint:
    'French label is required. Slug-based translations are used until both French and English labels are filled in.',
  serviceCategoryUpdateError: 'Failed to update service category',
  job_status: {
    open: 'Open',
    in_progress: 'In progress',
    completed: 'Completed',
    cancelled: 'Cancelled',
    paused: 'Paused',
    expired: 'Expired',
    reviewing_quotes: 'Reviewing quotes',
  },
  jobModeration: {
    editTitle: 'Edit project listing',
    editSubtitle: 'Changes will be saved and the recruiter will be notified with your reason.',
    editButton: 'Edit project',
    createButton: 'Create job',
    createSuccess: 'Job created successfully.',
    createRefreshError:
      'The job was created, but we could not refresh the list. Please reload the page.',
    unpublishButton: 'Unpublish',
    pauseButton: 'Pause listing',
    unpublishTitle: 'Unpublish project listing',
    pauseTitle: 'Pause project listing',
    unpublishExplanation:
      'This listing has no submissions. It will be removed from the marketplace and returned to draft (or cancelled if private).',
    pauseExplanation:
      'This listing has submissions. It will be paused to protect applicants while you resolve the issue.',
    reasonLabel: 'Reason for the recruiter',
    reasonPlaceholder: 'Explain what happened and why this action was taken…',
    reasonRequired: 'Please provide a reason of at least {{min}} characters.',
    reasonTooShort: 'Reason must be at least {{min}} characters.',
    confirmEdit: 'Save changes',
    confirmUnpublish: 'Unpublish listing',
    confirmPause: 'Pause listing',
    editSuccess: 'Project updated and recruiter notified.',
    unpublishSuccess: 'Listing unpublished and recruiter notified.',
    pauseSuccess: 'Listing paused and recruiter notified.',
    noCreditRefund: 'Publish credits are not refunded when an admin unpublishes a listing.',
    quotesCount: 'Submissions',
    allPublications: 'All publications',
    publication: {
      draft: 'Draft',
      published: 'Published',
      private: 'Private',
    },
    forceNotifyButton: 'Notify matching freelancers',
    forceNotifySuccess_one: 'Notified {{count}} freelancer.',
    forceNotifySuccess_other: 'Notified {{count}} freelancers.',
    forceNotifyNoMatches: 'No matching freelancers to notify.',
    forceNotifyError: 'This job is not eligible for notification, or something went wrong.',
    publishButton: 'Publish',
    publishTitle: 'Publish project listing',
    publishExplanation:
      'This listing was created on behalf of a shadow recruiter. Choose a listing priority and quote submission deadline to make it visible on the marketplace.',
    publishNoCredits: 'This action does not use or consume any credits.',
    publishListingTypeLabel: 'Listing priority',
    publishExpiresAtLabel: 'Quote submission deadline',
    confirmPublish: 'Publish listing',
    publishSuccess: 'Listing published.',
    publishRefreshError:
      'The listing was published, but we could not refresh the list. Please reload the page.',
    publishListingTypesLoadError: 'Could not load listing priorities.',
    publishRetry: 'Retry',
    publishErrorNotShadowJob: 'Only unclaimed shadow jobs can be published this way.',
    publishErrorNotPublishable: 'This listing is not in a publishable state.',
    publishErrorAlreadyPublished: 'This listing is already published.',
    assignToRecruiterButton: 'Assign to existing recruiter',
    assignTitle: 'Assign to existing recruiter',
    assignExplanation:
      'This transfers ownership of the listing directly to an existing recruiter account and removes any "Pigeons on behalf of…" branding.',
    assignSearchLabel: 'Search recruiters',
    assignSearchPlaceholder: 'Search by name, email, or company…',
    assignNoResults: 'No active recruiters found.',
    assignSearchError: 'Could not search recruiters. Try again.',
    confirmAssign: 'Assign listing',
    assignSuccess: 'Listing assigned to the recruiter.',
    assignRefreshError:
      'The listing was assigned, but we could not refresh the list. Please reload the page.',
    assignErrorNotAssignable:
      'Only jobs owned by Pigeons or an unclaimed shadow recruiter can be assigned this way.',
    assignErrorNotEligible: 'This account is not an active recruiter.',
    assignErrorHasQuoteActivity:
      'This listing already has quote requests and cannot be transferred this way.',
    assignErrorAdminNotActive: 'Your administrator account is not active.',
  },
  shadowRecruiters: {
    assignRejected:
      'Nothing was saved: {{jobs}} already belong to another recruiter and cannot be assigned to this shadow recruiter.',
    alreadyClaimed:
      'This shadow recruiter has already claimed their account. Refresh the page to see the latest details.',
  },
  campaigns: {
    title: 'Campaigns',
    subtitle: 'Build and edit landing pages for targeted ad campaigns.',
    add_item: 'New campaign',
    save: 'Save changes',
    saving: 'Saving...',
    delete: 'Delete',
    confirm_delete_item: 'Are you sure you want to delete this campaign?',
    save_success: 'Campaign saved successfully',
    save_error: 'Error while saving the campaign',
    delete_error: 'Error while deleting the campaign',
    create_error: 'Error while creating the campaign',
    unknown_error: 'Unknown error',
    upload: 'Upload image',
    choose_from_library: 'Choose from library',
    image_uploaded: 'Image uploaded successfully',
    image_upload_error: 'Error while uploading image',
    no_image: 'No image yet',
    published: 'Published',
    unpublished: 'Unpublished',
    preview_url: 'Public URL',
    view_leads: 'View leads',
    refresh: 'Refresh',
    leads_title: 'Leads',
    leads_empty: 'No leads yet for this campaign.',
    leads_error: 'Error while loading leads',
    fields: {
      slug: 'Slug',
      slug_hint: 'Used in the URL, e.g. /campaigns/montreal-photographers',
      profession: 'Profession',
      badge_fr: 'French badge',
      badge_en: 'English badge',
      headline_fr: 'French headline',
      headline_en: 'English headline',
      subheadline_fr: 'French subheadline',
      subheadline_en: 'English subheadline',
      hero_image: 'Hero image',
      hero_image_alt_fr: 'French hero image alt text',
      hero_image_alt_en: 'English hero image alt text',
      benefit_fr: 'French benefit {{order}}',
      benefit_en: 'English benefit {{order}}',
      gallery: 'Gallery images',
      cta_text_fr: 'French CTA button text',
      cta_text_en: 'English CTA button text',
    },
    leads_fields: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      created_at: 'Submitted',
    },
  },
} as const;
